module.exports = __webpack_public_path__ + "img/cupBlack.35a071ae.svg";